import styled from 'styled-components'

export const Block = styled('div')`
  border: 1px dashed gainsboro;
  padding: 8px;
  margin-bottom: 16px;
  .title {
    font-weight: bold;
  }
  .paymentButton {
    display: block;
    margin: 8px auto;
  }
`



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/styles.js